import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { TokenService, LogService, UtilsService } from 'abp-ng2-module';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import {AbpUserRefreshConfigurationService} from './app-user-refresh-configuration.service'
import {
    AuthenticateModel,
    AuthenticateResultModel,
    TokenAuthServiceProxy,
    UserServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { AppSessionService } from '@shared/session/app-session.service';

@Injectable()
export class AppAuthService {
    authenticateModel: AuthenticateModel;
    authenticateResult: AuthenticateResultModel;
    rememberMe: boolean;

    constructor(
        private _tokenAuthService: TokenAuthServiceProxy,
        private _router: Router,
        private _utilsService: UtilsService,
        private _tokenService: TokenService,
        private _logService: LogService,
        private _userService: UserServiceProxy,
        private _sessionService: AppSessionService,
        private _abpUserConfigurationService:AbpUserRefreshConfigurationService
    ) {
        this.clear();
    }

    logout(reload?: boolean): void {
        this._userService.updateLogoutTime().subscribe({
            next: () => {
                abp.auth.clearToken();
                abp.utils.deleteCookie(AppConsts.authorization.encryptedAuthTokenName);
                if (reload !== false) {
                    // location.href = AppConsts.appBaseUrl;
                    this._router.navigate(['/account/login']);
                }
            },
            error: () => {
                // Even if API fails, ensure logout proceeds
                abp.auth.clearToken();
                abp.utils.deleteCookie(AppConsts.authorization.encryptedAuthTokenName);
                if (reload !== false) {
                    // location.href = AppConsts.appBaseUrl;
                    this._router.navigate(['/account/login']);;
                }
            }
        });
    }


    authenticate(finallyCallback?: () => void): void {
        finallyCallback = finallyCallback || (() => { });

        this._tokenAuthService
            .authenticate(this.authenticateModel)
            .pipe(
                finalize(() => {
                    finallyCallback();
                })
            )
            .subscribe((result: AuthenticateResultModel) => {
                this.processAuthenticateResult(result);
            });
    }

    private processAuthenticateResult(authenticateResult: AuthenticateResultModel) {
        this.authenticateResult = authenticateResult;

        if (authenticateResult.accessToken) {
            // Successfully logged in
            this.login(
                authenticateResult.accessToken,
                authenticateResult.encryptedAccessToken,
                authenticateResult.expireInSeconds,
                this.rememberMe
            );
        } else {
            // Unexpected result!

            this._logService.warn('Unexpected authenticateResult!');
            this._router.navigate(['account/login']);
        }
    }

    private login(
        accessToken: string,
        encryptedAccessToken: string,
        expireInSeconds: number,
        rememberMe?: boolean
    ): void {
        const tokenExpireDate = rememberMe ? new Date(new Date().getTime() + 1000 * expireInSeconds) : undefined;

        this._tokenService.setToken(accessToken, tokenExpireDate);

        this._utilsService.setCookieValue(
            AppConsts.authorization.encryptedAuthTokenName,
            encryptedAccessToken,
            tokenExpireDate,
            abp.appPath
        );

        // this._router.navigate(['/app/about']).then(success => {
        //     if (!success) {
        //         console.error('Navigation to /app/about failed');
        //         // fallback: full page reload
        //         window.location.href = '/app/about';
        //     }
        // });
        // this._userService.getCurrentUser().subscribe(user => {

        //     if (user.userType === 1) {

        //         this._sessionService.init().then(() => {
        //             this._router.navigate(['/app/customer-dashboard/dashboard']);
        //         });
        //     } else {

        //         // Previous functionality same
        //         this._router.navigate(['/app/about']).then(success => {
        //             if (!success) {
        //                 console.error('Navigation to /app/about failed');
        //                 window.location.href = '/app/about';
        //             }
        //         });

        //     }

        // });

        this._sessionService.init()
    .then(() => this._abpUserConfigurationService.refresh())
    .then(() => {

        const user = this._sessionService.user;

        if (user?.userType === 1) {
            return this._router.navigate([
                '/app/customer-dashboard/dashboard'
            ]);
        }

        if (user?.userType === 4) {
            return this._router.navigate([
                '/app/salesperson-dashboard/dashboard'
            ]);
        }

        return this._router.navigate(['/app/about']);
    });

        // this._sessionService.init().then(() => {

        //     const user = this._sessionService.user;

        //     if (user?.userType === 1) {
        //         this._router.navigate(['/app/customer-dashboard/dashboard']);
        //     }
        //     else if (user?.userType === 4) {
        //         this._router.navigate(['/app/salesperson-dashboard/dashboard']);
        //     }
        //      else {
        //         this._router.navigate(['/app/about']);
        //     }

        // });

        // let initialUrl = UrlHelper.initialUrl;
        // if (initialUrl.indexOf('/login') > 0) {
        //     initialUrl = AppConsts.appBaseUrl;
        // }

        // this._router.navigate(['/app/about']);
        // location.href = initialUrl;
    }

    private clear(): void {
        this.authenticateModel = new AuthenticateModel();
        this.authenticateModel.rememberClient = false;
        this.authenticateResult = null;
        this.rememberMe = false;
    }
}
